export const APP_ROUTES = Object.freeze({
  ROOT: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  HOME: "/home",
  PRIVACY: "/privacidade",
  TERMS: "/termos",
});

export const PUBLIC_ROUTES = Object.freeze([
  APP_ROUTES.ROOT,
  APP_ROUTES.LOGIN,
  APP_ROUTES.REGISTER,
  APP_ROUTES.PRIVACY,
  APP_ROUTES.TERMS,
]);

export const AUTH_ROUTES = Object.freeze([
  APP_ROUTES.LOGIN,
  APP_ROUTES.REGISTER,
]);

export const LEGAL_ROUTES = Object.freeze([
  APP_ROUTES.PRIVACY,
  APP_ROUTES.TERMS,
]);

const AUTH_MODE_BY_ROUTE = Object.freeze({
  [APP_ROUTES.LOGIN]: "signin",
  [APP_ROUTES.REGISTER]: "signup",
});

const AUTH_ROUTE_BY_MODE = Object.freeze({
  signin: APP_ROUTES.LOGIN,
  signup: APP_ROUTES.REGISTER,
  reset: APP_ROUTES.LOGIN,
  recovery: APP_ROUTES.LOGIN,
});

export const normalizeAppPathname = (pathname = APP_ROUTES.ROOT) => {
  const cleanPathname = pathname || APP_ROUTES.ROOT;
  if (cleanPathname.length <= 1) return APP_ROUTES.ROOT;
  return cleanPathname.replace(/\/+$/, "");
};

export const getAppRouteFromPathname = (pathname = APP_ROUTES.ROOT) => {
  const normalizedPathname = normalizeAppPathname(pathname);

  if (
    PUBLIC_ROUTES.includes(normalizedPathname) ||
    normalizedPathname === APP_ROUTES.HOME
  ) {
    return normalizedPathname;
  }

  return null;
};

export const isAuthRoute = (route) => AUTH_ROUTES.includes(route);

export const getAuthModeFromRoute = (route) => AUTH_MODE_BY_ROUTE[route] || null;

export const getAuthRouteForMode = (mode) =>
  AUTH_ROUTE_BY_MODE[mode] || APP_ROUTES.LOGIN;

export const buildAppUrl = (route) => {
  if (typeof window === "undefined") return route;
  return `${window.location.origin}${route}`;
};
